// Reveal-on-scroll as progressive enhancement.
// Content is visible by default. We only hide elements that start BELOW the
// first viewport, then reveal them as they scroll in. A failsafe guarantees
// nothing ever stays hidden (background tabs, slow observers, etc.).
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!els.length) return;

    var vh = window.innerHeight || document.documentElement.clientHeight;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    els.forEach(function (el) {
      // Anything in or near the first viewport shows instantly (never hidden).
      if (el.getBoundingClientRect().top < vh * 0.9) return;
      el.classList.add('reveal-hidden');
      observer.observe(el);
    });

    // Failsafe: clear hidden state no matter what after 2.5s.
    window.setTimeout(function () {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }, 2500);
  }

  // Garde anti double-soumission sur les formulaires d'ajout au panier :
  // un double-clic ajouterait deux exemplaires d'un produit numérique.
  function initCartAddGuard() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (form.dataset.submitted === 'true') {
        e.preventDefault();
        return;
      }
      form.dataset.submitted = 'true';
      window.setTimeout(function () {
        form.dataset.submitted = '';
      }, 4000);
    });
  }

  function start() {
    initReveal();
    initCartAddGuard();
  }

  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
